import React from 'react';

import { IPlacementInfo } from 'src/components/ListOfLayoutApartments/types';
import { IFilterHeaderInfo } from 'src/typings/filter';
import { useTranslations } from 'src/hooks/translataions';
import { UseNumberFormat } from 'src/hooks';
import { useGenerateShowingInfo } from '../../hooks';
import { useStyles } from './styles';

export const InfoAdditional: React.FC<IPlacementInfo> = ({
  itemData,
  filterConfigurator,
  displayedType,
}) => {
  const styles = useStyles({});
  const { getTranslations } = useTranslations();
  const renderItems: { [key: string]: IFilterHeaderInfo | any } = useGenerateShowingInfo(filterConfigurator[displayedType]);
  const { numberSeparator, replaceFraction } = UseNumberFormat();

  return (
    <div className={styles.apartmentAdditionalInfo}>
      {Object.keys(renderItems).map((renderItem, index) => {
        const renderData = renderItems[renderItem];
        const placementData = itemData[renderItem];

        if (itemData[renderItem]) {
          return (
            <div
              key={renderItem}
              className={styles.additionalInfo}
            >
              <span>
                {renderData['use-name'] && `${getTranslations(renderItem)}`}
              </span>
              <span style={{ textAlign: 'right' }}>
                {`${renderData['value-prefix'] ? renderData['value-prefix'] : ''} `}
                {` ${numberSeparator(replaceFraction(getTranslations(placementData)), renderItem)} `}
                {`${renderData['value-sufix'] ? renderData['value-sufix'] : ''}`}
              </span>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};
